<template>

	<TopMenu :breadcrumbs="breadcrumbs"/>
	<Navigator />

	<div class="component-filter">
		<div class="range-picker">
			<DatePicker v-model="filter.begin" label="Дата от" :isClear="false" size="sm" />
			<DatePicker v-model="filter.end" label="Дата до" :isClear="false" size="sm" />
		</div>
		<div class="btn-group">
			<a class="btn btn--medium btn--default btn--inline" @click="saveFilter($event)">
				<div class="btn--text"> Применить фильтры </div>
				<div class="btn--loader"> </div>
			</a>
			<a class="btn btn--medium btn--outline btn--inline" @click="clearFilter">
				<div class="btn--text"> Сбросить фильтры </div>
				<div class="btn--loader"> </div>
			</a>
		</div>
	</div>

	
	<div class="load-container load" v-if="isLoad"></div>

	<template v-if="!isLoad">

	  <CollapseContainer 
	  	v-for="item in modules" 
	  	:key="item.id_module" 
	  	class="collapse--transparent"
	  	ref="module">

	    <template v-slot:header>
	    	<div class="c-ico" :style="{background: iconColor(item.statusIndex).bg}">
					<component :is="item.num" :color="iconColor(item.statusIndex).color"></component>
				</div>
				{{ item.name }} &nbsp; <span :style="{'color': iconColor(item.statusIndex).color, 'font-weight': 600}"> {{ item.statusIndex + '%' }} </span>
	    </template>

	    <template v-slot:body>

    		<div class="stat">
    			<div class="stat__left">
  						<div class="stat__info">
  							<div class="stat__hint"> Оценка состояния системы </div>
  							<div class="stat__num" :style="{'color': iconColor(item.statusIndex).color}"> {{ item.statusIndex }}% </div>
  						</div>
  						<SpeedometerSmall :progress="item.statusIndex" :color="iconColor(item.statusIndex).color" class="stat__speedometer"/>
    			</div>
					
					<img class="stat__separator" src="@/assets/img/arrow-down-grey.svg">

    			<div class="stat__right">
    				<div class="stat__item">
    					<div class="stat__label"> Доля собранных данных </div>
    					<div class="stat__value">
    						<div class="stat__num" :style="{'color': iconColor(item.speedometer).color}"> {{ item.speedometer }}% </div>
    						<ProgressBar :percent="item.speedometer" :hideNumber="true" :color="iconColor(item.speedometer).color"/>
    					</div>
    				</div>
    				<div class="stat__item">
    					<div class="stat__label"> Состояние на основе собранных данных </div>
    					<div class="stat__value">
    						<div class="stat__num" :style="{'color': iconColor(item.percent).color}"> {{ item.percent }}% </div>
    						<ProgressBar :percent="item.percent" :hideNumber="true" :color="iconColor(item.percent).color"/>
    					</div>
    				</div>
    			</div>
    		</div>


    		<CollapseContainer 
			  	v-for="epic in item.epics" 
			  	:key="epic.id_epic" 
			  	class="collapse--transparent epic">

			    <template v-slot:header>
			    	<div class="epic__title"> 
		    			<div class="epic__num"> {{ epic.num }} </div>
		    			{{ epic.name }} 
		    		</div>
			    </template>

			    <template v-slot:body>
			    	
			    	<div class="stat">
		    			<div class="stat__left">
	  						<div class="stat__info">
	  							<div class="stat__hint"> Оценка состояния системы </div>
	  							<div class="stat__num" :style="{'color': iconColor(epic.statusIndex).color}"> {{ epic.statusIndex }}% </div>
	  						</div>
	  						<SpeedometerSmall :progress="epic.statusIndex" :color="iconColor(epic.statusIndex).color" class="stat__speedometer"/>
		    			</div>
							<img class="stat__separator" src="@/assets/img/arrow-down-grey.svg">
		    			<div class="stat__right">
		    				<div class="stat__item">
		    					<div class="stat__label"> Доля собранных данных </div>
		    					<div class="stat__value">
		    						<div class="stat__num" :style="{'color': iconColor(epic.speedometer).color}"> {{ epic.speedometer }}% </div>
    								<ProgressBar :percent="epic.speedometer" :hideNumber="true" :color="iconColor(epic.speedometer).color"/>
		    					</div>
		    				</div>
		    				<div class="stat__item">
		    					<div class="stat__label"> Состояние на основе собранных данных </div>
		    					<div class="stat__value">
		    						<div class="stat__num" :style="{'color': iconColor(epic.percent).color}"> {{ epic.percent }}% </div>
		    						<ProgressBar :percent="epic.percent" :hideNumber="true" :color="iconColor(epic.percent).color"/>
		    					</div>
		    				</div>
		    			</div>
		    		</div>

			    </template>

			  </CollapseContainer>

	    </template>
	  </CollapseContainer>
	</template>

</template>

<script setup>

	import TopMenu from '@/components/TopMenu.vue';
	import Navigator from '@/components/reports/Navigator.vue';
	import DatePicker from '@/components/ux/DatePicker.vue';
  import CollapseContainer from '@/components/ux/CollapseContainer.vue'
	import ProgressBar from '@/components/ux/ProgressBar.vue';
	import SpeedometerSmall from '@/components/ux/SpeedometerSmall.vue';

	

  import A from '@/components/icons/modules/A.vue';
  import B from '@/components/icons/modules/B.vue';
  import C from '@/components/icons/modules/C.vue';
  import D from '@/components/icons/modules/D.vue';
  import E from '@/components/icons/modules/E.vue';
  import F from '@/components/icons/modules/F.vue';
  import G from '@/components/icons/modules/G.vue';
  import H from '@/components/icons/modules/H.vue';
  import I from '@/components/icons/modules/I.vue';
  import J from '@/components/icons/modules/J.vue';
  import K from '@/components/icons/modules/K.vue';
  import L from '@/components/icons/modules/L.vue';

</script>

<script>

  export default {
    
    name: 'PageReportsSystemHouse',
    
    components: { A, B, C, D, E, F, G, H, I, J, K, L },

    data: () => ({
      	isLoad: false,
      	breadcrumbs: [],
      	house: null,
      	modules: [],
      	state: {
      		A: { action: 'review' },
      		B: { action: 'review' },
      		C: { action: 'review' },
      		D: { action: 'review' },
      		E: { action: 'review' },
      		F: { action: 'review' },
      		G: { action: 'review' },
      		H: { action: 'review' },
      		I: { action: 'review' },
      	},
      	filter: {
	      	begin: null,
	      	end: null,
      	},
    }),

    computed: {
    	house_id () {
    		return this.$route.params.house_id;
    	},
    	iconColor () {
    		return (percent) => {
    			if(percent >= 90) {
    				return {color: 'rgba(var(--cozh-green-code), 1)', bg: 'rgba(var(--cozh-green-code), .08)'};
    			}
					if(percent < 90 && percent > 70) {
    				return {color: 'rgba(var(--cozh-orange-code), 1)', bg: 'rgba(var(--cozh-orange-code), .08)'};
					}
					if(percent <= 70) {
    				return {color: 'rgba(var(--cozh-red-code), 1)', bg: 'rgba(var(--cozh-red-code), .08)'};
					}
    		}
    	},
    },
    created () {
    	this.filter.begin = this.$moment().startOf('year').format('YYYY-MM-DD');
    	this.filter.end = this.$moment().format('YYYY-MM-DD');
			this.loadData();
    	Promise.all([this.loadHouse()])
		    .then(() => {
		      this.beforeRender();
		    })
		    .catch(()=> {})
    },
    methods: {
    	beforeRender () {
    		this.breadcrumbs = [
	        	{name: this.$route.meta.name, link: this.$route.matched[0].path, ico: this.$route.meta.ico},
	        	{name: this.house.address, link: ''},
	        ];
    	},

    	async clearFilter (e) {
		 		const btn = e.currentTarget;
		 		btn.classList.add('btn--load');
    		this.filter.begin = this.$moment().startOf('year').format('YYYY-MM-DD');
    		this.filter.end = this.$moment().format('YYYY-MM-DD');
    		await this.loadData();
		 		btn.classList.remove('btn--load');
    	},

    	async saveFilter (e) {
		 		const btn = e.currentTarget;
		 		btn.classList.add('btn--load');
	    	await this.loadData();
		 		btn.classList.remove('btn--load');
    	},

    	buildfilter () {
    		const param = new URLSearchParams({});
    		if(this.filter.begin !== null) {
      		param.set("begin", this.filter.begin + 'T00:00:00.802333+00:00');
        }
        if(this.filter.end !== null) {
        	param.set("end", this.filter.end + 'T23:59:59.802443+00:00');
        }
        return param;
    	},

    	async loadData () {
    		this.isLoad = true;
      	const param = this.buildfilter();
      	const {data} = await this.$store.dispatch('getAnaliticsSystemModules', {house_id: this.house_id, data: param});
      	this.modules = data;
    		this.isLoad = false;
    	},

    	async loadHouse () {
      		this.house = await this.$store.dispatch('getHouse', {house_id: this.house_id});
    	},
    }
  }
</script>

<style scoped>

	.stat {
		background-color: #fff;
    border-radius: 8px;
    padding: 20px;
    margin-top: 5px;
    display: flex;
    flex-direction: row;
    align-items: flex-start;
    justify-content: flex-start;
    gap: 10px;
    align-items: stretch
	}
	.stat__left {
		border: 1px solid var(--cozh-light-grey);
    display: flex;
    flex-direction: row;
    border-radius: 8px;
    align-items: center;
    justify-content: space-between;
    padding: 20px;
    gap: 30px;
	}
	.stat__info {
		display: flex;
    flex-direction: column;
    width: 120px;
    min-width: 120px;
    gap: 15px;
	}
	.stat__speedometer {
		height: 102px;
    margin: 0px -13px;
	}
	.stat__hint {
		font-weight: 400;
		font-size: 14px;
		line-height: 1.33;
		color: var(--cozh-black);
	}
	.stat__num {
		font-style: normal;
		font-weight: 700;
		font-size: 28px;
		line-height: 1;
		color: #FF9100;
		width: 92px;
	}

	.stat__right {
		border: 1px solid var(--cozh-light-grey);
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    justify-content: flex-start;
    width: 100%;
    border-radius: 8px;
	}
	.stat__item {
		padding: 20px;
		display: flex;
		flex-direction: row;
		align-items: center;
		justify-content: flex-start;
		gap: 30px;
		width: 100%;
	}
	.stat__item:not(:last-child) {
		border-bottom: 1px solid var(--cozh-light-grey);
	}
	.stat__label {
		min-width: 30%;
		font-size: 13px;
	}
	.stat__value {
		width: 100%;
		display: flex;
		flex-direction: row;
		align-items: center;
		justify-content: flex-start;
		gap: 20px;
	}
	.stat__separator {
		transform: rotate(90deg);
	}




	.epic.collapse {
		margin-left: 10px;
    width: calc(100% - 10px);
    margin-top: 5px;
	}
	.epic.collapse:not(:last-child) {
		margin-bottom: 0px;
	}
	.epic.collapse:deep(.collapse__header) {
		padding: 15px 20px;
    min-height: auto;
	}

	.epic__title {
    font-size: 16px;
    font-weight: 500;

    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: flex-start;
    gap: 10px;
	}

	.epic__num {
		color: var(--cozh-grey);
    font-size: 14px;
    font-weight: 600;
	}

	.epic .stat {
		margin-left: 10px;
	}


	.collapse:not(:last-child) {
		margin-bottom: 5px;
	}

	.collapse:deep(.collapse__header) {
		padding: 15px;
		font-weight: 500;
	}

	.collapse:deep(.collapse__body) {
		padding: 0px;
	}

	.c-ico {
		height: 50px;
    width: 50px;
    border-radius: 50%;
    background-color: #E9F1F4;
    margin-right: 15px;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
	}



	.component-filter {
		background-color: #fff;
		padding: 15px;
		border-radius: 8px;
		display: flex;
    	flex-direction: row;
    	align-items: center;
    	gap: 10px;
    	justify-content: space-between;
    	position: relative;
    	margin-bottom: 10px;
	}

	.component-filter__item {
		flex: 1 1 0;
  		width: 0;
	}
	.component-filter a {
		width: fit-content;
	}
	
</style>